<template>
  <div class="host page">
    <DataTable
      title="Специальности"
      :service="service"
      :fields="tableFileds"
      :scheme="scheme"
      :pageSize="5"
    />
  </div>
</template>

<script>
import DataTable from '@app/components/uikit/DataTable';
import { specialtyApi } from '@app/services';

export default {
  components: { DataTable },
  data: () => ({
    service: specialtyApi,
    scheme: {
      controls: {
        title: {
          type: 'text',
          label: 'Название',
          placeholder: 'Введите название...'
        }
      }
    },
    tableFileds: [
      {
        name: 'title',
        label: 'Название',
        value: value => value.title
      }
    ]
  })
};
</script>

